import gql from 'graphql-tag';

// Tenant isolation: uses OR [org_some, parentOrg_some] to include child org ad groups.
// The campaign launcher needs visibility into child org creatives for assignment.
// For library view (current org only), use GET_ADGROUP_CREATIVES instead.
// See commit ce64ea218 (Apr 2023) — "display data from child org, MUST NOT display from parent org".
const GET_ADGROUP_CREATIVES_LAUNCHER = gql`
  query adgroupmedias($orgId: ID!) {
    adGroupCreativeses(
      where: {
        OR: [{ org_some: { id: $orgId } }, { org_some: { parentOrg_some: { id: $orgId } } }]
      }
    ) {
      id
      adProviderId
      name
      isAmplifyDefault
      medias(where: { flag: true }) {
        id
        name
        size
        fileType
        height
        width
        key
        url
        type
        org {
          id
          name
        }
        sharedWith {
          name
        }
        mediaNotes
        mediaHasNotes
      }
      flag
      org {
        id
        name
      }
    }
  }
`;

export default GET_ADGROUP_CREATIVES_LAUNCHER;
